import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DxLookupComponent, DxLookupModule } from 'devextreme-angular';
import { DxoDropDownOptionsModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    templateUrl: './link-item-picker.component.html',
    selector: 'app-link-item-picker',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxLookupModule, DxoDropDownOptionsModule, DxTemplateModule, NgTemplateOutlet]
})

export class LinkItemPickerComponent {
    @Input() isRequired = false;
    @Input() isReadOnly = false;
    @Input() datasource: any[] = [];
    @Input() displayExpr: string;
    @Input() valueExpr: string;
    @Input() placeholder: string;
    @Input() itemTemplate: TemplateRef<any>;
    @Input() fieldTemplate: TemplateRef<any>;

    @Output() selectedItemChange = new EventEmitter<any>();
    @Input() selectedItem: any;

    @Output() valueChange = new EventEmitter<any>();
    @Input() value: any;

    @ViewChild('itemLookup', { static: true }) private itemLookup: DxLookupComponent;

    itemSelectedInternal(e: any): void {
        if (e && e.value) {
            const item = e.value as any;

            if (this.selectedItemChange.observers.length > 0) {
                this.itemLookup.isValid = true;
                this.selectedItemChange.emit(item);
                this.selectedItem = item;
            }
        }
        else if (e && !e.value) {
            if (this.isRequired) {
                this.itemLookup.isValid = false;
            }
            this.selectedItemChange.emit(null);
            this.selectedItem = null;
        }

        this.valueChange.emit(this.value);
    }
}
